import { getLaunchDarklyFlag } from '@/utils/launchDarklyFlags';
import FeatureFlags from '@/constants/FeatureFlags';

interface MiddlewareContext {
  redirect: (path: string) => void;
}

/**
 * Page middleware for the Premium People migration upgrade surface
 * (`/upgrade/premium-people`), referenced via the page's `middleware` option so
 * it only runs for that route rather than on every navigation.
 *
 * Gates the page behind the `premium-people-migration` LaunchDarkly flag
 * (cohort-targeted T1–T7). Auth is already enforced by the global auth
 * middleware, so the user is signed in by the time this runs. Accounts outside
 * the migration cohort are bounced to the dashboard.
 */
export default async ({ redirect }: MiddlewareContext) => {
  const inCohort = await getLaunchDarklyFlag(
    FeatureFlags.PREMIUM_PEOPLE_MIGRATION
  );

  if (!inCohort) {
    redirect('/dashboard');
  }
};
